export default __webpack_public_path__ + "static/media/landing-background.78cf5040.jpg";